export default class AdminExcuseDuties {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminExcuseDutiesRoute, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminExcuseDutiesRoute}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminExcuseDutiesRoute}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  downloadPDF(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminExcuseDutiesRoute}/${id}/download-pdf`, {})
  }
}
